import React, { useContext, useEffect, useState } from "react";
import "./Product_Info.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import White_Round_Btn from "../../common_components/common_button/White_Round_Btn";
import WhiteButton from "./../../common_components/common_button/WhiteButton";
import { useNavigate } from "react-router-dom";
import ProductModal from "./../../common_components/common_modal/ProductModal";
import { getProduct } from "../../../features/admin/product/productdetails/Slice";
import { useDispatch, useSelector } from "react-redux";
import { IDS } from "../../../utils/IDS";
import { Context } from "../../../utils/context";
import Cookies from "js-cookie";
import BuyModal from "../../common_components/common_modal/buy_now_modal/Buy_Modal";
import { GETProfile } from "../../../features/admin/auth/Slice";

const Product_Info = () => {
  const dispatch = useDispatch();
  const { userdata } = useContext(Context);
  const productsdetails = useSelector((state) => state.product.productdetails);

  const userGet = useSelector((state) => state?.auth?.login?.getCustomerData);

  const products = productsdetails?.products;
  const productdetail = productsdetails?.products?.productdetails;
  const productImages = products?.productimages || [];

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  useEffect(() => {
    dispatch(getProduct());
    dispatch(GETProfile());
  }, [dispatch]);

  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [startIndex, setStartIndex] = useState(0);

  // const handleBuyNow = () => {
  //   Cookies.remove("shippingData");
  //   Cookies.remove("orderData");

  //   navigate("/cart");
  // };

  const handleBuyNow = () => {
    const isProfileComplete = userGet?.name && userGet?.email;

    if (!isProfileComplete) {
      setShowBuyModal(true);
      return;
    }

    Cookies.remove("shippingData");
    Cookies.remove("orderData");

    navigate("/cart");
  };

  const images = [
    "/images/product_info_page/img1.png",
    // "/images/product_info_page/img2.png",
    // "/images/product_info_page/img3.png",
    // "/images/product_info_page/img1.png",
    // "/images/product_info_page/img2.png",
    // "/images/product_info_page/img3.png",
  ];

  const [selectedImage, setSelectedImage] = useState(images[0]);
  const [swiperInstance, setSwiperInstance] = useState(null);
  const handleImageClick = (imageSrc) => {
    setSelectedImage(imageSrc);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth < 575);
  const [showBuyModal, setShowBuyModal] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 575);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section className="Product_Info">
      <div className="container">
        <div className="main_div">
          <div className="row">
            <div className="col-md-6">
              <div className="main_left_div">
                <div className="desktop_slider">
                  <div className="verticle_swiper_div">
                    <Swiper
                      slidesPerView={3}
                      centeredSlides={false}
                      centeredSlidesBounds={true}
                      modules={[Autoplay]}
                      onSwiper={(swiper) => setSwiperInstance(swiper)}
                      direction={isMobile ? "horizontal" : "vertical"}
                      className="verticleSwiper"
                      breakpoints={{
                        0: {
                          slidesPerView: 3,
                          spaceBetween: 8,
                        },
                        576: {
                          slidesPerView: 4,
                          spaceBetween: 10,
                        },
                        768: {
                          slidesPerView: 4,
                          spaceBetween: 20,
                        },
                        992: {
                          slidesPerView: 3,
                          spaceBetween: 20,
                        },
                        1200: {
                          slidesPerView: 3,
                          spaceBetween: 20,
                        },
                      }}
                      pagination={{ clickable: true }}
                    >
                      {productImages?.map((img, index) => (
                        <SwiperSlide key={img?.id}>
                          <div
                            className="img_container"
                            onClick={() => {
                              setSelectedImage(
                                `${IDS.IMG_URL}${img?.product_image}`,
                              );
                              setStartIndex(index);
                              setShowModal(true);
                            }}
                          >
                            <img
                              src={`${IDS.IMG_URL}${img?.product_image}`}
                              className="prod_img"
                              alt="product"
                            />
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </div>

                <div className="left_img_div">
                  <img
                    src={`${IDS.IMG_URL}${products?.image}`}
                    className="left_img"
                    alt=""
                  />
                </div>
              </div>
            </div>

            <div className="mobile_swiper">
              <div className="verticle_swiper_div">
                <Swiper
                  slidesPerView={3}
                  centeredSlides={false}
                  centeredSlidesBounds={true}
                  modules={[Autoplay]}
                  onSwiper={(swiper) => setSwiperInstance(swiper)}
                  breakpoints={{
                    0: {
                      slidesPerView: 3,
                      spaceBetween: 8,
                    },
                    576: {
                      slidesPerView: 4,
                      spaceBetween: 10,
                    },
                    768: {
                      slidesPerView: 4,
                      spaceBetween: 20,
                    },
                    992: {
                      slidesPerView: 3,
                      spaceBetween: 20,
                    },
                    1200: {
                      slidesPerView: 3,
                      spaceBetween: 20,
                    },
                  }}
                  pagination={{ clickable: true }}
                >
                  {productImages?.map((slide, index) => (
                    <SwiperSlide key={index}>
                      <div
                        className="img_container"
                        onClick={() => {
                          setSelectedImage(process.env.PUBLIC_URL + slide);
                          setStartIndex(index);
                          setShowModal(true);
                        }}
                      >
                        <img
                          src={`${IDS.IMG_URL}${slide?.product_image}`}
                          className="prod_img"
                        />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>

            <div className="col-md-6">
              <div className="content_div">
                <p className="simple_text">
                  *Buy One Product To Join The Community And Start Your Journey.
                </p>
                <p className="green_text">{products?.name}</p>
                <p className="black_text">
                  {htmlToReactParser.parse(products?.description)}
                </p>

                <div className="price_div">
                  <p className="dot"></p>
                  <p className="price_text">
                    ₹ {products?.price}/-
                    <span className="inner_text">Only</span>
                  </p>
                </div>

                <div className="descn_div">
                  <p className="desn_text">
                    Form: <span>{productdetail?.form}</span>{" "}
                  </p>
                  <p className="desn_text">
                    Net Quantity: <span>{productdetail?.quantity}</span> Tablets
                  </p>
                  <p className="desn_text">
                    Suitable For: <span>{productdetail?.suitable} </span>
                  </p>
                  <p className="desn_text">
                    Usage: <span>{productdetail?.usage}</span>{" "}
                  </p>
                </div>

                <div className="btn_holder">
                  <WhiteButton
                    className="w-btn"
                    title={"Buy Now"}
                    bg="#ffff"
                    color="#000"
                    hoverColor="#f35f37"
                    hoverBg={"#000"}
                    onClick={handleBuyNow}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ProductModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        startIndex={startIndex}
        images={productImages}
      />

      {/* <BuyModal
        show={showBuyModal}
        handleClose={() => setShowBuyModal(false)}
        handleDelete={handleBuyNow}
      /> */}

      <BuyModal
        show={showBuyModal}
        handleClose={() => {
          setShowBuyModal(false);

          navigate("/profile-settings");
        }}
      />
    </section>
  );
};

export default Product_Info;
